export const GET_DATA_AGENT_BY_TEAM = 'GET_DATA_AGENT_BY_TEAM';
export const OPEN_NEW_AGENT_DIALOG = 'OPEN_NEW_AGENT_DIALOG';
export const CLOSE_NEW_AGENT_DIALOG = 'CLOSE_NEW_AGENT_DIALOG';
export const OPEN_DELETE_AGENT_DIALOG = 'OPEN_DELETE_AGENT_DIALOG';
export const CLOSE_DELETE_AGENT_DIALOG = 'CLOSE_DELETE_AGENT_DIALOG';
export const SUBMIT_SUCCEED = 'SUBMIT_SUCCEED';
export const SUBMIT_FAILED = 'SUBMIT_FAILED';
export const RESET_MESSAGE = 'RESET_MESSAGE';
export const MOVE_USER_TEAM = 'MOVE_USER_TEAM';
export const REMOVE_USER_TEAM = 'REMOVE_USER_TEAM';